/**
 * @generated SignedSource<<4d4a6c369fbd4b450526047f770c1d50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type collapse_toggleCollapsedMutation$variables = {
  blockKey: string;
  collapsed: boolean;
  noteId: string;
};
export type collapse_toggleCollapsedMutation$data = {
  readonly NoteBlock_SetCollapsed: {
    readonly block: {
      readonly note: {
        readonly collapsedBlockKeys?: ReadonlyArray<string>;
        readonly id: string;
      };
    };
  } | null;
};
export type collapse_toggleCollapsedMutation = {
  response: collapse_toggleCollapsedMutation$data;
  variables: collapse_toggleCollapsedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collapsed"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blockKey",
        "variableName": "blockKey"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "kind": "ObjectValue",
    "name": "blockId"
  },
  {
    "kind": "Variable",
    "name": "collapsed",
    "variableName": "collapsed"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collapsedBlockKeys",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "collapse_toggleCollapsedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteBlockSetCollapsed",
        "kind": "LinkedField",
        "name": "NoteBlock_SetCollapsed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "collapse_toggleCollapsedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteBlockSetCollapsed",
        "kind": "LinkedField",
        "name": "NoteBlock_SetCollapsed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f1d22200d3182f83791626c160b0a3f1",
    "id": null,
    "metadata": {},
    "name": "collapse_toggleCollapsedMutation",
    "operationKind": "mutation",
    "text": "mutation collapse_toggleCollapsedMutation(\n  $noteId: ID!\n  $blockKey: String!\n  $collapsed: Boolean!\n) {\n  NoteBlock_SetCollapsed(blockId: {noteId: $noteId, blockKey: $blockKey}, collapsed: $collapsed) {\n    block {\n      note {\n        __typename\n        id\n        ... on Note {\n          collapsedBlockKeys\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e9698d2c69b9b0f46e0ce4de65bb939";

export default node;
